"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnlineOrderingStatus = exports.Endpoints = exports.QueryKeys = void 0;
var QueryKeys;
exports.QueryKeys = QueryKeys;

(function (QueryKeys) {
  QueryKeys["Store"] = "Store";
  QueryKeys["GetClosestStores"] = "GetClosestStores";
  QueryKeys["FindDeliveryStore"] = "FindDeliveryStore";
  QueryKeys["CanStoreDeliver"] = "CanStoreDeliver";
})(QueryKeys || (exports.QueryKeys = QueryKeys = {}));

var Endpoints;
exports.Endpoints = Endpoints;

(function (Endpoints) {
  Endpoints["Store"] = "store/location";
  Endpoints["OrderingHours"] = "store";
  Endpoints["GetClosestStores"] = "GetClosestStores";
  Endpoints["FindDeliveryStore"] = "v1/search/find-delivery-store";
})(Endpoints || (exports.Endpoints = Endpoints = {}));

var OnlineOrderingStatus;
exports.OnlineOrderingStatus = OnlineOrderingStatus;

(function (OnlineOrderingStatus) {
  OnlineOrderingStatus[OnlineOrderingStatus["errored"] = 0] = "errored";
  OnlineOrderingStatus[OnlineOrderingStatus["enabled"] = 1] = "enabled";
  OnlineOrderingStatus[OnlineOrderingStatus["enabledStoreClosed"] = 2] = "enabledStoreClosed";
  OnlineOrderingStatus[OnlineOrderingStatus["offline"] = 3] = "offline";
  OnlineOrderingStatus[OnlineOrderingStatus["disabledForCurrentStore"] = 4] = "disabledForCurrentStore";
  OnlineOrderingStatus[OnlineOrderingStatus["disabledForAllStores"] = 5] = "disabledForAllStores";
  OnlineOrderingStatus[OnlineOrderingStatus["disabledStoreClosed"] = 6] = "disabledStoreClosed";
})(OnlineOrderingStatus || (exports.OnlineOrderingStatus = OnlineOrderingStatus = {}));